import { OFFER_AND_DEALS_ACTION, GET_PAST_ORDERS, FETCH_CUSTOMER_DETAILS, FETCH_CUSTOMER_RECOMMENDATIONS_PRODUCTS, ADD_NEW_ADDRESS, DELETE_SAVED_ADDRESS, FETCH_CUSTOMER_DETAILS_SUCCESS, UPDATE_CUSTOMER_INFO, DELETE_CUSTOMER_ACCOUNT, MARKETING_PREFERENCE, FETCH_CUSTOMER_INFO_SUCCESS, FETCH_CUSTOMER_DETAILS_ERROR, RESET_CUSTOMER_INFO, UPDATE_ISNEW_CUSTOMER, UPDATE_EXTERNAL_CUSTOMER_ID, UPDATE_BRAZE_SDK, } from '../../constants';
export function getOfferAndDeals(payload) {
    return {
        type: OFFER_AND_DEALS_ACTION,
        payload,
    };
}
export function getPastOrders(payload) {
    return {
        type: GET_PAST_ORDERS,
        payload,
    };
}
export function getCustomerInfo(userData = {}) {
    return {
        type: FETCH_CUSTOMER_DETAILS,
        userData
    };
}
export function getCustomerInfoSuccess(response) {
    return {
        type: FETCH_CUSTOMER_DETAILS_SUCCESS,
        response,
    };
}
export function getCustomerInfoError() {
    return {
        type: FETCH_CUSTOMER_DETAILS_ERROR,
    };
}
export function updateIsNewCustomer() {
    return {
        type: UPDATE_ISNEW_CUSTOMER,
    };
}
export function updateCustomerInfo(payload) {
    return {
        type: UPDATE_CUSTOMER_INFO,
        payload,
    };
}
export function deleteCustomerAccount(payload) {
    return {
        type: DELETE_CUSTOMER_ACCOUNT,
        payload,
    };
}
export function updateExternalCustomerId(payload) {
    return {
        type: UPDATE_EXTERNAL_CUSTOMER_ID,
        payload,
    };
}
export function getCustomerRecommendations() {
    return {
        type: FETCH_CUSTOMER_RECOMMENDATIONS_PRODUCTS,
    };
}
export function addNewAddress(payload, successCallback) {
    return {
        type: ADD_NEW_ADDRESS,
        payload,
        successCallback,
    };
}
export function deleteAddress(payload, successCallback) {
    return {
        type: DELETE_SAVED_ADDRESS,
        payload,
        successCallback,
    };
}
export function getGuestInfoAction(payload) {
    return {
        type: FETCH_CUSTOMER_INFO_SUCCESS,
        response: { customer: { basic: { id: payload.customerId } } },
    };
}
export function marketingPreference(payload) {
    return {
        type: MARKETING_PREFERENCE,
        payload,
    };
}
export const resetCustomerInfo = () => ({
    type: RESET_CUSTOMER_INFO,
});
export const updateBrazeSDKFlag = (payload) => ({
    type: UPDATE_BRAZE_SDK,
    payload,
});
